<template>
	<section id="intro" class="main-content intro">
		<div class="row">
			<slot name="content">
				<div class="columns column6">
					<h2 v-if="subtitle" class="subtitle">
						<span>{{ subtitle }}</span>
					</h2>
					<h1>
						{{ title }}
					</h1>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="content" />
					<p v-if="bookingID">
						<a
							href="#"
							target="_blank"
							rel="noopener noreferrer"
							:data-roomID="bookingID"
							class="button button-cta"
						>
							{{ $t('bookThisRoom') }}
						</a>
					</p>
				</div>
			</slot>
		</div>
		<slot name="bgImage" />
	</section>
</template>

<script setup>
defineProps({
	title: { type: String, default: '' },
	subtitle: { type: String, default: '' },
	content: { type: String, default: '' },
	bookingID: { type: String, default: '' },
});
</script>
